import { Snackbar, Alert, type AlertColor } from "@mui/material";
import { useState } from "react";

export const useToast = () => {
  const [toast, setToast] = useState<{
    open: boolean;
    message: React.ReactNode | null;
    severity: AlertColor;
  }>({
    open: false,
    message: null,
    severity: "success",
  });

  const showToast = (message: React.ReactNode, severity: AlertColor) => {
    setToast({ open: true, message, severity });
  };

  const closeToast = () => setToast({ ...toast, open: false });

  const ToastComponent = (
    <Snackbar open={toast.open} autoHideDuration={3000} onClose={closeToast}>
      <Alert onClose={closeToast} severity={toast.severity}>
        {toast.message}
      </Alert>
    </Snackbar>
  );

  return { showToast, ToastComponent };
};
